import { z } from 'zod';
/** Owned instance UUID is separate from the catalog character ID. */
export const OwnedCharacterSchema = z.object({
    id: z.string().uuid(),
    characterId: z.string().min(1),
});
export const CollectionResponseSchema = z.object({
    characters: z.array(OwnedCharacterSchema),
});
//# sourceMappingURL=collection.js.map